import * as yup from "yup";
import config from "../../config";

export const defaultMessages = {
  success:
    "Your message has been successfully sent. We will get back to you soon.",
  error: "There was a problem submitting your form. Please try again later.",
};

// Phone is optional: empty passes. When provided it must have a basic phone
// structure and contain 7–15 actual digits to reject dummy/malformed entries.
export const isValidPhone = (value) => {
  if (!value) return true;
  if (!/^\+?[\d\s().-]+$/.test(value)) return false;
  const digits = value.replace(/\D/g, "");
  return digits.length >= 7 && digits.length <= 15;
};

export const contactFormSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  email: yup
    .string()
    .required("Email is required")
    .email("Please enter a valid email address (e.g., user@example.com)")
    // yup's .email() accepts addresses without a TLD (e.g. "test@gmail"), so
    // require a proper dotted domain with a 2+ char TLD.
    .matches(
      /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
      "Please enter a valid email address (e.g., user@example.com)"
    ),
  phone: yup
    .string()
    .transform((value) => (typeof value === "string" ? value.trim() : value))
    .test(
      "phone-valid",
      "Please enter a valid phone number (7–15 digits)",
      isValidPhone
    ),
  message: yup.string().required("Message is required").max(500),
});

export const sendContactMessage = async (data) => {
  const response = await fetch(`${config.endpoints.baseUrl}/api/contact`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  let result = null;
  try {
    result = await response.json();
  } catch {
    result = null;
  }

  if (!response.ok) {
    // API returns { message, errors: { field: [msg] } } on validation errors.
    const fieldError = result?.errors
      ? Object.values(result.errors).flat()[0]
      : null;
    throw new Error(result?.message || fieldError || defaultMessages.error);
  }

  return result?.message || defaultMessages.success;
};
